import SectionHeading from '@/components/feature/SectionHeading';
import { testimonials } from '@/mocks/site';

export default function VictimVoices() {
  return (
    <section className="bg-background-50">
      <div className="mx-auto w-full max-w-content px-4 py-16 md:px-6 md:py-20">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-12 lg:gap-14">
          <div className="lg:col-span-5">
            <div className="h-72 w-full overflow-hidden rounded-lg md:h-[420px]">
              <img
                src="https://readdy.ai/api/search-image?query=an%20investigative%20desk%20scene%20with%20a%20magnifying%20glass%20over%20printed%20documents%20under%20warm%20lamp%20light%2C%20muted%20dark%20brown%20and%20amber%20tones%2C%20cinematic%20documentary%20photography%2C%20high%20detail&width=1000&height=1200&seq=mb-section-report-01&orientation=portrait"
                alt="反诈档案整理的桌面场景，放大镜下的纸质材料"
                title="缅北黑料受害者经历与反诈口碑"
                className="h-full w-full object-cover object-top"
              />
            </div>
          </div>

          <div className="lg:col-span-7">
            <SectionHeading
              eyebrow="亲历者与读者"
              title="他们读过之后，做了什么"
              desc="档案的价值不在于猎奇，而在于让读到它的人做出不一样的判断。以下反馈经本人同意整理发布。"
            />
            <div className="mt-8 space-y-5">
              {testimonials.map((t) => (
                <figure key={t.name} className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
                  <i className="ri-double-quotes-l text-2xl text-primary-400" aria-hidden="true"></i>
                  <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
                    {t.quote}
                  </blockquote>
                  <figcaption className="mt-4 flex items-center gap-3 border-t border-background-200 pt-4">
                    <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-100 text-secondary-800">
                      <i className="ri-user-3-line" aria-hidden="true"></i>
                    </span>
                    <span className="text-sm">
                      <strong className="font-semibold text-foreground-900">{t.name}</strong>
                      <span className="ml-2 text-xs text-foreground-500">{t.role}</span>
                    </span>
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}